import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink, Form, Input, Button, Modal, ModalBody } from 'reactstrap';
import { TransitionGroup, SwitchTransition, CSSTransition } from "react-transition-group";
import classNames from 'classnames';
import { getNavigate } from '../../../navigationService';
import { teamsListActions, getCurrentTeamsList, getTeamsForCurrentTeamsList } from '../../../core/teams-list';
import LoadingIndicator from '../../components/loading-indicator';
import CreateModal from '../../components/teams/create-modal';
import TeamItem from '../../components/teams/team-item';

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'mine',
      mineTeams: [],
      filter: '',
      animationClass: {
        appearActive: 'animate__animated animate__slideInRight',
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__slideInRight',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__slideOutLeft',
      },
      animationClassTabs: {
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__fadeIn',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__fadeOut',
      },
      modal_create: false,
      nodeRef: createRef(null),
      nodeTabsRef: createRef(null)
    };

    this.toggle = this.toggle.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.refreshMineTeams = this.refreshMineTeams.bind(this);
    this.navigate = getNavigate();
  }

  componentDidMount() {
    this.props.searchTeams({
      owner: 1,
    });

    this.setState({
      activeTab: 'mine'
    })
  }

  componentDidUpdate(oldProps, oldState) {
    const { teams } = this.props;

    if (oldState.mineTeams !== teams && teams.size > 0) {
      this.refreshMineTeams();
    }
  }

  toggle = (tab) => {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
        filter: ''
      });
      this.props.searchTeams({
        owner: tab === "mine" ? 1 : 0,
      });
    }
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modal_create: !prevState.modal_create
    }));
  };

  refreshMineTeams = () => {
    const { teams } = this.props;
    if (this.state.activeTab === 'mine') {
      this.setState({
        mineTeams: teams.size > 0 ? teams : []
      });
    }
  }

  handleFilterChange = ({ event: { target } }) => {
    const { activeTab } = this.state;

    this.setState({ filter: target.value });
    this.props.searchTeams({
      owner: activeTab === "mine" ? 1 : 0,
      query: target.value
    });
  }

  handleBack(e) {
    e.preventDefault();
    this.navigate(-1);
  }

  render() {
    const { animationClass, activeTab, animationClassTabs, mineTeams, filter, nodeRef, nodeTabsRef } = this.state;

    const { displayLoadingIndicator, user, teams } = this.props;
    if (user.checked && !user.id)
      return <LoadingIndicator />;

    return (
      <>
        <div className="container-fluid h-100">
          <div className="view overflow-hidden team-content h-100">
            <TransitionGroup component={null}>
              <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key='admin-page' appear>
                <div className="w-100 h-100 d-flex flex-column" ref={nodeRef}>

                  <div className='mb-3 pt-md-4'>
                    <h1 className='mb-2 mb-lg-0 libre-caslon-text-regular h3-md h4'>Teams</h1>
                  </div>

                  <div className='d-flex align-items-center gap-10 mb-4'>
                    <div className='flex-fill'>
                      <Form onSubmit={e => { e.preventDefault() }}>
                        <div className="search-member-input rounded border d-flex align-items-center">
                          <span className='text-muted ml-2 my-1 d-block' >
                            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill='currentColor'>
                              <g>
                                <path d="M18.1,17.4L18.1,17.4L18.1,17.4c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3
                                      c0,0.1-0.1,0.2-0.2,0.3s-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.2l-3.7-3.7l0,0l0,0
                                      c-1.4,1.1-3.2,1.6-5,1.4c-1.8-0.2-3.5-1-4.7-2.4C2.2,12.6,1.6,10.8,1.6,9c0.1-1.8,0.8-3.5,2.1-4.8c1.3-1.3,3-2,4.8-2.1
                                      c1.8-0.1,3.6,0.6,4.9,1.8c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.4,5l0,0l0,0L18.1,17.4z M3.4,9.3L3.4,9.3
                                      C3.4,10.7,3.9,12,5,13c1,1,2.4,1.6,3.8,1.6h0c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4c0.4-1,0.5-2.1,0.3-3.1
                                      c-0.2-1-0.7-2-1.5-2.8S10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2C3.7,7.1,3.4,8.2,3.4,9.3z"/>
                                <path d="M17.5,18.9c-0.1,0-0.2,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2L13.1,15c-1.5,1.1-3.3,1.6-5.1,1.5
                                      c-1.8-0.2-3.5-1-4.7-2.4c-1.2-1.4-1.8-3.1-1.8-5c0.1-1.8,0.8-3.6,2.1-4.9c1.3-1.3,3-2,4.9-2.1c1.8-0.1,3.6,0.6,5,1.8
                                      c1.4,1.2,2.2,2.9,2.4,4.7c0.2,1.8-0.3,3.6-1.5,5.1l3.8,3.8l0,0c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4s0,0.2-0.1,0.4
                                      s-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C17.7,18.9,17.6,18.9,17.5,18.9z M13.1,14.8L13.1,14.8l3.8,3.8c0.1,0.1,0.2,0.1,0.3,0.2
                                      c0.2,0.1,0.4,0.1,0.6,0c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3
                                      c0-0.1-0.1-0.2-0.2-0.3l-0.1,0l0,0l-3.7-3.7l0.1-0.1c1.1-1.4,1.6-3.2,1.4-5c-0.2-1.8-1-3.4-2.4-4.6s-3.1-1.8-4.9-1.8
                                      C6.7,2.2,5,3,3.7,4.2c-1.3,1.3-2,3-2.1,4.8c-0.1,1.8,0.6,3.5,1.8,4.9c1.2,1.4,2.8,2.2,4.6,2.4C9.8,16.5,11.6,16,13.1,14.8
                                      L13.1,14.8z M8.8,14.7c-1.5,0-2.8-0.6-3.8-1.6c-1-1-1.6-2.4-1.6-3.8l0,0c0-1.1,0.3-2.1,0.9-3c0.6-0.9,1.4-1.6,2.4-2
                                      c1-0.4,2.1-0.5,3.1-0.3c1.1,0.2,2,0.7,2.8,1.5c0.8,0.8,1.3,1.7,1.5,2.8c0.2,1.1,0.1,2.1-0.3,3.1c-0.4,1-1.1,1.8-2,2.4
                                      C10.9,14.4,9.8,14.7,8.8,14.7z M3.4,9.3C3.4,10.7,4,12,5,13c1,1,2.3,1.6,3.8,1.6c1.1,0,2.1-0.3,3-0.9c0.9-0.6,1.6-1.4,2-2.4
                                      c0.4-1,0.5-2,0.3-3.1c-0.2-1-0.7-2-1.5-2.7C11.8,4.7,10.8,4.2,9.8,4c-1-0.2-2.1-0.1-3.1,0.3c-1,0.4-1.8,1.1-2.4,2
                                      C3.7,7.2,3.4,8.2,3.4,9.3L3.4,9.3z"/>
                              </g>
                            </svg>
                          </span>
                          <Input type="text" className="border-0" placeholder="Filter by Team Name or Member Names" value={filter} onChange={(event) => this.handleFilterChange({ event })} />
                        </div>
                      </Form>
                    </div>

                    <Button color="green-light" size='sm' onClick={this.toggleModal}>
                      <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="currentColor" className='mt-n1'>
                        <path d="M14.2,8c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H8.8v4.8c0,0.2-0.1,0.4-0.2,0.5
                      c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5V8.7H2.5C2.3,8.7,2.1,8.7,2,8.5C1.8,8.4,1.8,8.2,1.8,8
                      c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h4.8V2.5c0-0.2,0.1-0.4,0.2-0.5C7.6,1.8,7.8,1.7,8,1.7c0.2,0,0.4,0.1,0.5,0.2
                      c0.1,0.1,0.2,0.3,0.2,0.5v4.8h4.8c0.2,0,0.4,0.1,0.5,0.2C14.2,7.6,14.2,7.8,14.2,8z"/>
                      </svg>
                      <span className='d-none d-md-inline-block pl-1'>Create Team</span>
                    </Button>
                  </div>

                  <Nav className="mb-3 text-center" tabs>
                    <NavItem className="flex-xs-fill">
                      <NavLink className={classNames({ active: activeTab === 'mine', 'px-md-4 h5': true })} onClick={() => { this.toggle('mine'); }}><span className='font-weight-semibold'>My Teams</span></NavLink>
                    </NavItem>
                    <NavItem className="flex-xs-fill">
                      <NavLink className={classNames({ active: activeTab === 'all', 'px-md-4 h5': true })} onClick={() => { this.toggle('all'); }}><span className='font-weight-semibold'>All Teams</span></NavLink>
                    </NavItem>
                  </Nav>

                  <div className="content-tabs h-100" style={{ overflow: 'hidden' }}>
                    <SwitchTransition>
                      <CSSTransition nodeRef={nodeTabsRef} classNames={animationClassTabs} timeout={{ enter: 1000, exit: 300 }} key={activeTab}>
                        <div ref={nodeTabsRef}>
                          <TabContent activeTab={activeTab} className="pb-5 h-100">
                            <TabPane tabId="mine" className='h-100'>
                              {mineTeams.size > 0 &&
                                <>
                                  <div className="overflow-hidden team-grid grid-3">
                                    {mineTeams.map(item =>
                                      <TeamItem item={item} key={item.id} />
                                    )}
                                  </div>
                                </>
                              }
                              {!mineTeams.size &&
                                <div className='d-flex justify-content-center w-100 h-100'>
                                  <div className='my-auto'>
                                    <p>You have not yet created any teams. Click on the button above to create your first team.</p>
                                  </div>
                                </div>
                              }
                            </TabPane>
                            <TabPane tabId="all">
                              <div className="overflow-hidden team-grid grid-3">
                                {teams.map(item =>
                                  <TeamItem item={item} key={item.id} />
                                )}
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </CSSTransition>
                    </SwitchTransition>
                  </div>
                  {
                    displayLoadingIndicator &&
                    <LoadingIndicator />
                  }
                </div>
              </CSSTransition>
            </TransitionGroup>
          </div>
        </div>

        <Modal isOpen={this.state.modal_create} toggle={this.toggleModal} size='sm' centered>
          <ModalBody>
            <CreateModal toggleModal={this.toggleModal} />
          </ModalBody>
        </Modal>
      </>

    );
  }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const teams_list = getCurrentTeamsList(state, props);

  return {
    user: state.user,
    teams_list: teams_list,
    teams: getTeamsForCurrentTeamsList(state, props),
    displayLoadingIndicator: (teams_list && teams_list.isPending) || false,
  };
};

const mapDispatchToProps = {
  searchTeams: teamsListActions.searchTeams,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPage);